import api from '@/api/index.js'

const account_deletions = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_DELETIONS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_DELETIONS: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_ACCOUNT_DELETIONS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    LoadAccountDeletions({commit}) {
      commit('SET_ACCOUNT_DELETIONS_LOADING', true)
      return api.get('account-deletions?limit=150&offset=0')
        .then((response) => {
          commit('SET_ACCOUNT_DELETIONS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_DELETIONS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_deletions
